import { applyMiddleware, createStore } from 'redux';
// import createLogger from 'redux-logger';
import rootReducer from '../reducers';
import reduxThunk from 'redux-thunk';

// const logger = createLogger()

const initalState = {
  page : {
    inProgress: '',
    contentLoaded: false,
    selectedPage: '',
    headerStyle: 'full',
  },
  imageStatus: {
    imagesLoaded: 0
  },
}

export default function configureStore() {
  const store = createStore(rootReducer, initalState, applyMiddleware(reduxThunk))
  // const store = createStore(rootReducer, initalState, applyMiddleware(logger, reduxThunk))

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept(rootReducer, () => {
      const nextRootReducer = rootReducer
      store.replaceReducer(nextRootReducer)
    })
  }
  return store
}



// WEBPACK FOOTER //
// ./src/redux/store/configure-store.js